import { useEffect, useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    Typography,
} from '@mui/material';

import { StyledDialogTitle } from '../StyledComponents';
import { STATES, stateStr } from '../../models/kosaState';
import useErrorHandler from '../../services/error-handler';
import KosaService from '../../services/kosa-service';

const KosaStateDialog = ({ kosa, onApply, onClose }) => {
    const pushError = useErrorHandler();

    const [state, setState] = useState('');

    useEffect(() => {
        if (kosa) {
            setState(kosa.state_id);
        }
    }, [kosa]);

    const onSetState = (e) => {
        setState(+e.target.value || '');
    };

    const onApplyClick = async () => {
        const nKosa = { ...kosa.kosa, state_id: state };
        try {
            await KosaService.createOrUpdate(nKosa);
            onApply();
        } catch (e) {
            pushError(e);
        }
    };

    const renderStatusItems = () => {
        return Object.values(STATES).map((state_id) => {
            return (
                <MenuItem value={state_id} key={state_id}>
                    {stateStr(state_id)}
                </MenuItem>
            );
        });
    };

    if (!kosa) return null;
    return (
        <Dialog open={Boolean(kosa)} onClose={onClose}>
            <StyledDialogTitle>Статус косы {kosa.sn}</StyledDialogTitle>
            <DialogContentText>
                <Typography sx={{ textAlign: 'center' }}>
                    Текущий статус: <b>{stateStr(kosa.state_id)}</b>{' '}
                </Typography>
            </DialogContentText>
            <DialogContent>
                <Stack direction="row" alignItems="center" spacing={2}>
                    <Typography>Выберите статус: </Typography>
                    <FormControl variant="outlined" size="small">
                        <InputLabel id="state-select-label">Статус</InputLabel>
                        <Select label="Статус" labelId="state-select-label" value={state} onChange={onSetState}>
                            {renderStatusItems()}
                        </Select>
                    </FormControl>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" disabled={state === kosa.state_id} onClick={onApplyClick}>
                    Применить
                </Button>
                <Button variant="outlined" onClick={onClose}>
                    Отмена
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default KosaStateDialog;
